import React, { useEffect, useState } from "react";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import { ToastContainer } from "react-toastify";
import List from "../../../components/List/List";
import Loader from "../../../components/Loader/Loader";

const TimeSlotList = () => {
  const headers = ["Start Time", "End Time"];
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await adminRequest.get(`${BASE_URL}/timeSlot/list`);
      const fetchedRows = response.data.data.map((e) => ({
        displayData: [e.startTime, e.endTime],
        uuid: e.uuid,
      }));
      setRows(fetchedRows);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const getMenuItems = (row) => [
    {
      link: "create",
      text: "Create",
      // onClick: (e) => {
      //   e.preventDefault();
      //   handleBlock(row.uuid);
      // },
    },
  ];
  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <List
            title="Time Slot List"
            createButtonLabel="Create Time Slot"
            headers={headers}
            rows={rows.map((row) => row.displayData)}
            link="create"
            showEyeViewIcon={false}
            showFilterIcon={false}
            getMenuItems={(row) =>
              getMenuItems(rows.find((r) => r.displayData === row))
            }
          />
        </>
      )}
      <ToastContainer position="top-center" />
    </div>
  );
};

export default TimeSlotList;
